/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { MetaMcpServer, MetaMcpServer$inboundSchema } from "./metamcpserver.js";

/**
 * Result type for listing meta MCP servers
 */
export type ListMetaMcpServersResult = {
  metaMcpServers: Array<MetaMcpServer>;
};

/** @internal */
export const ListMetaMcpServersResult$inboundSchema: z.ZodMiniType<
  ListMetaMcpServersResult,
  unknown
> = z.pipe(
  z.object({
    meta_mcp_servers: z.array(MetaMcpServer$inboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      "meta_mcp_servers": "metaMcpServers",
    });
  }),
);

export function listMetaMcpServersResultFromJSON(
  jsonString: string,
): SafeParseResult<ListMetaMcpServersResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListMetaMcpServersResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListMetaMcpServersResult' from JSON`,
  );
}
